import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStoreUpdatePredicateOrder = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const updatePredicateOrder = useStore(store, (s) => s.updatePredicateOrder);

    return updatePredicateOrder;
};
